import { cn } from "@/lib/utils";
import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { forwardRef } from "react";

const iconThemeMap: Record<string, JSX.Element> = {
  light: <Sun size={16} />,
  dark: <Moon size={16} />,
  system: <Monitor size={16} />,
};

const themes = ["light", "dark", "system"];

type Props = {
  className?: string;
};

const ThemeToggle = forwardRef<HTMLDivElement, Props>(({ className }, ref) => {
  const { setTheme, theme } = useTheme();

  return (
    <div className={cn("flex gap-2", className)} ref={ref}>
      {themes.map((t) => {
        const isActive = theme === t;

        return (
          <button
            key={t}
            className={cn(
              "w-6 h-6 flex justify-center items-center text-groq-orange rounded-[2px] hover:bg-accent",
              isActive && "bg-accent",
            )}
            type="button"
            onClick={() => setTheme(t)}
          >
            {iconThemeMap[t]}
          </button>
        );
      })}
    </div>
  );
});

export { ThemeToggle };
